import { GetAvsKvpsResponse } from "@/app/api/avs-kvps/route";
import { getAvsKvpsRequestSchema } from "@/lib/schemas/avs-kvps";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const AVS_KVPS_ENDPOINT = "/api/avs-kvps";

export const invalidateAvsKvpsQuery = createInvalidateQuery(AVS_KVPS_ENDPOINT);

export const useAvsKvpsQuery = createQueryHook<GetAvsKvpsResponse>(
  AVS_KVPS_ENDPOINT,
  getAvsKvpsRequestSchema,
);
